import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { Button } from 'ustore-ui';

import { ToastService } from '../../shared/services/toast.service';
import { ForgotPasswordService } from '../../core/services/forgot-password.service';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { AuthLayoutComponent } from '../../shared/layouts/auth-layout.component';
import { CustomInputComponent } from '../../shared/components/custom-input/custom-input.component';
import { I18nPipe } from '../../shared/pipes/i18n.pipe';
import { I18nService } from '../../core/services/i18n.service';

@Component({
  selector: 'umkt-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIconModule,
    Button,
    RouterModule,
    FooterComponent,
    AuthLayoutComponent,
    CustomInputComponent,
    I18nPipe
  ],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['../../../assets/style/login-register.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotForm!: FormGroup;
  loading: boolean = false;
  error: string = '';
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private toastService = inject(ToastService);
  private forgotPasswordService = inject(ForgotPasswordService);
  private i18nService = inject(I18nService);


  ngOnInit(): void {
    this.forgotForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  sendRecovery() {
    this.loading = true;
    this.error = '';

    const email = this.forgotForm.value.email;

    this.forgotPasswordService.forgotPassword(email).subscribe({
      next: (response) => {
        this.loading = false;
        if (response.status === 'success') {
          this.toastService.showSuccess(
            this.i18nService.instant('pages.forgotPassword.messages.success'), 
            4000, 
            'top-center'
          );
          this.router.navigate(['/login']);
        } else {
          const err = response.msg
          this.error = err;
          this.toastService.showError(err, 5000, 'top-center');
        }
      },
      error: (error) => {
        this.loading = false;
        this.toastService.showError(error.error.msg, 5000, 'top-center');
      }
    });
  }

  // Getters para facilitar o acesso aos controles
  get emailControl() {
    return this.forgotForm.get('email');
  }
}
